import { readCookies as e } from "./cookies/cookie-parser-util.js";
import { GA_CLIENT_ID_COOKIE_NAME as t, parseGaClientIdCookie as n } from "./cookies/ga-client-id.js";
import { ErrorResponse as r, createErrorResponse as i } from "./errorResponse.js";
import { getUserGroup as a } from "./getUserGroup.js";
import { i as o, n as s, r as c, t as l } from "./chunks/repubs-BojZE0nv.js";
import { REPUBS as u } from "@cx-modules/constants";
import { REPUB_COUNTRY as d, SUPPORTED_REPUB_NAMES as f } from "@cx-web/domain-types";
//#region src/getPromiseResult.ts
var p = (e) => {
	if (e.status !== "rejected") return e.value;
}, m = (e, t) => {
	let n = p(e);
	if (n == null) throw new Response(null, {
		status: 500,
		statusText: t
	});
	return n;
}, h = (e, t) => {
	if (e.status === "rejected") throw e.reason instanceof Response ? e.reason : new Response(null, {
		status: 500,
		statusText: t
	});
	if (e.value == null) throw new Response(null, {
		status: 500,
		statusText: t
	});
	return e.value;
};
//#endregion
//#region src/repub-util.ts
function g(e) {
	return !!u[e];
}
//#endregion
//#region src/getRepubFromURL.ts
function _(e) {
	let t = e.pathname.split("/")[1]?.toUpperCase();
	return !g(t) || !u[t] ? u.OC.name : t;
}
//#endregion
//#region src/isErrorWithStatus.ts
var v = (e) => typeof e == "object" && !!e && "status" in e;
//#endregion
//#region src/repub-meta.ts
function y(e) {
	let t = Object.entries(u).reduce((t, [n, r]) => ({
		...t,
		[n]: e === r.name
	}), {}), n = e.toLowerCase(), r = f.some((e) => t[e]), i = r ? d[e] : "uk";
	return {
		repubIs: t,
		repubIsOCPlus: r,
		repubPath: s(e),
		repubHomeUrl: l(e),
		repubLowerCase: n,
		repubCountry: i
	};
}
function b(e) {
	let { repubIsOCPlus: t } = y(e);
	return t;
}
//#endregion
//#region src/updateI18nSingleton.ts
var x = /* @__PURE__ */ new WeakSet();
function S(e, t, n) {
	if (!x.has(e)) {
		e.init({
			lng: t,
			fallbackLng: "en-US",
			defaultNS: "label",
			resources: n,
			initImmediate: !1
		}), x.add(e);
		return;
	}
	e.language !== t && e.changeLanguage(t);
	for (let [t, r] of Object.entries(n)) if (r) for (let [n, i] of Object.entries(r)) e.addResourceBundle(t, n, i, !1, !0);
}
//#endregion
export { r as ErrorResponse, t as GA_CLIENT_ID_COOKIE_NAME, i as createErrorResponse, p as getPromiseResult, _ as getRepubFromURL, l as getRepubHomeUrl, y as getRepubMetaFromRepub, s as getRepubPath, a as getUserGroup, v as isErrorWithStatus, b as isOcPlusRepub, g as isValidRepub, n as parseGaClientIdCookie, e as readCookies, c as removeRepubPrefix, o as repubs, h as requireErrorAwarePromiseResult, m as requirePromiseResult, S as updateI18nSingleton };
